/**
 * Procedure Categories and Procedures for MS / Diploma in Otorhinolaryngology (MS ENT) students
 * Extracted with strict evidence from official NMC PDF (Page 5-6: "Psychomotor Domain")
 */
export const ENT_PROCEDURES = {
  "Emergency Airway & ENT Procedures": [
    "Tracheostomy",
    "Anterior & Posterior Nasal Packing",
    "Ear Packing and Syringing",
    "Foreign Body Removal from Airway, Nose, and Throat",
    "Basic & Advanced Life Support (CPR) & Airway Management",
    "Endotracheal Intubation",
    "Nasogastric Feeding & Gastrostomy Setup",
  ],
  "Surgical, Biopsy & Minor ENT Procedures": [
    "Wound Suturing, Dressings and Care of Wounds",
    "Fine Needle Aspiration Cytology (FNAC)",
    "Tissue Biopsy (Ear, Nose, Throat & Oral Cavity)",
    "Aspiration from Serous Cavities",
    "Lumbar Puncture",
  ],
};

export const ENT_CATEGORIES = Object.keys(ENT_PROCEDURES);

export const isDiplomaInENTDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  const isEntWord =
    d === "ent" ||
    d.startsWith("ent ") ||
    d.endsWith(" ent") ||
    d.includes(" ent ") ||
    d.includes("e.n.t");
  const hasEar = d.includes("ear") && !d.includes("clear") && !d.includes("heart") && !d.includes("linear");
  return (
    isEntWord ||
    d.includes("otorhinolaryngology") ||
    d.includes("dlo") ||
    hasEar ||
    d.includes("nose")
  );
};

export const isMSInENTDept = isDiplomaInENTDept;
